module.exports = {
    unauthorized: [
        {
            name: 'orders',
            id: 'orders'
        }
    ],
    manager: [
        {
            name: 'orders',
            id: 'orders'
        },
        {
            name: 'users',
            id: 'users'
        },
        {
            name: 'statistic',
            id: 'statistic'
        }
    ],
    client: [
        {
            name: 'orders',
            id: 'orders'
        },
        {
            name: 'personal',
            id: 'personal'
        }
    ]
};



// WEBPACK FOOTER //
// ./actions/compositions/account.js